<template>
  <div class="master-recipe-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('list') }}</strong>
              <div class="card-actions">

              </div>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col cols="5"></b-col>
                <b-col cols="2">
                  <b-form-select v-model="filter.actived"
                                 :options="[{text: $t('all'), value: null}, {text: $t('active'), value: 1}, {text: $t('inactive'), value: 0}]">
                  </b-form-select>
                </b-col>
                <b-col cols="4">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected"
                                     position="prepend" v-bind:all="true" v-model="field">
                    </select-dropdown>
                    <b-form-input v-model="key"></b-form-input>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search"></i> {{$t('search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
<!--                <b-col cols="1" v-if="$auth.check(model + '.create')">-->
                <b-col cols="1">
                  <router-link :to="{name: model + '_create'}">
                    <b-button variant="primary">
                      <i class="fa fa-plus"></i> {{$t('create')}}
                    </b-button>
                  </router-link>
                </b-col>
              </b-row>
              <div class="clearfix">
                <hr/>
              </div>
              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm header-pointer">
                  <thead>
                  <tr>
                    <th scope="col" v-for="item in dataTable.header" :key="item.id" @click="updateSort(item.name)"
                        :class="item.sort ? 'cursor-pointer' : ''">
                      <i class="fa fa-sort-amount-asc text-muted"
                         v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted"
                         v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span>{{$t(item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('active')}}</th>
                    <th scope="col">{{$t('daily_batch')}}</th>
                    <th scope="col">{{$t('action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in dataTable.body" :key="item.id">
                    <td scope="row" v-for="field in dataTable.header" :key="field.id">
                      <span v-if="field.render != null" v-html="field.render(item[field.name])"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row">
                      <b-button size="sm" variant="success" @click="updateStatusItem(item.id, 0, 'active')"
                                v-if="item.is_active == 1">
<!--                        v-if="item.is_active == 1 && $auth.check(model + '.update.status')">-->
                        <i class="fa fa-check"></i>
                      </b-button>
                      <b-button size="sm" variant="danger" @click="updateStatusItem(item.id, 1, 'active')"
                                v-if="item.is_active != 1">
<!--                        v-if="item.is_active != 1 && $auth.check(model + '.update.status')">-->
                        <i class="fa fa-times"></i>
                      </b-button>
                    </td>
                    <td scope="row">
                      <b-button size="sm" variant="success" @click="updateStatusItem(item.id, 0, 'daily_batch')"
                                v-if="item.is_daily_batch == 1">
<!--                        v-if="item.is_daily_batch == 1 && $auth.check(model + '.update.status')">-->
                        <i class="fa fa-check"></i>
                      </b-button>
                      <b-button size="sm" variant="danger" @click="updateStatusItem(item.id, 1, 'daily_batch')"
                                v-if="item.is_daily_batch != 1">
<!--                        v-if="item.is_daily_batch != 1 && $auth.check(model + '.update.status')">-->
                        <i class="fa fa-times"></i>
                      </b-button>
                    </td>
                    <td scope="row" width="130">
                      <router-link :to="{name: model + '_edit', params: {id: item.id}}">
<!--                        v-if="$auth.check(model + '.update') || $auth.check(model + '.detail')">-->
                        <b-button size="sm" variant="primary">
                          <i class="fa fa-edit"></i>
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.paginate"
                                v-model="dataTable.offset"/>
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.paginate" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import SelectDropdown from '../../../../components/Partials/SelectDropdown'
  import {fetchAll, changeStatusItem} from '@/api/master_recipe'

  export default {
    name: 'MasterRecipeList',
    components: {
      SelectDropdown
    },
    data: function () {
      return {
        model: 'master_recipe',
        field: null,
        key: null,
        filter: {
          options: [],
          selected: null,
          actived: null
        },
        dataTable: {
          body: [],
          header: [
            {
              name: 'code',
              search: true,
              sort: false
            },
            {
              name: 'name',
              search: true,
              sort: false
            },
            {
              name: 'plucode',
              search: true,
              sort: true
            },
            {
              name: 'usage',
              search: true,
              sort: true
            },
            {
              name: 'uom_name',
              search: false,
              sort: true
            },
            {
              name: 'expired_in',
              search: true,
              sort: true
            },
            {
              name: 'price',
              search: true,
              sort: true
            }
          ],
          sort: {
            field: null,
            type: 'asc'
          },
          offset: 1,
          total: 0,
          paginate: 10,
          source: null
        }
      }
    },
    methods: {
      /**
       * Update status of object (active/inactive)
       * @param id and status of object
       */
      updateStatusItem (id, value, type) {
        this.$Progress.start()
        let data = {
          id: id
        }
        if (type === 'active') {
          data.is_active = value
        } else {
          data.is_daily_batch = value
        }
        changeStatusItem(data).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.refreshData()
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update sort name and sort type of data table
       * @param field
       */
      updateSort(field) {
        for (let i in this.dataTable.header) {
          if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
            return
          }
        }
        if (this.dataTable.sort.field != field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type == 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      /**
       * Refresh data of data table
       */
      refreshData() {
        this.$Progress.start()
        let params = {
          offset: this.dataTable.offset,
          paginate: this.dataTable.paginate,
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        }
        let str_search_key = ''
        if (this.field == null && !this._.isEmpty(this.key)) {
          for (let i in this.dataTable.header) {
            if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
              if (str_search_key != '') {
                str_search_key += ',' + this.dataTable.header[i].name
              } else {
                str_search_key += this.dataTable.header[i].name
              }
            }
          }
          params.search_key = str_search_key
          params.search_value = this.key.trim()
        } else {
          if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
            params.search_key = this.field
            params.search_value = this.key.trim()
          }
        }
        if (this.filter.actived != null) {
          params.is_active = this.filter.actived
        }
        fetchAll(params).then((response) => {
          this.dataTable.body = response.data.data.items
          this.dataTable.total = response.data.data.total
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      for (let i in this.dataTable.header) {
        if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
          this.filter.options.push(this.dataTable.header[i].name)
        }
        if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
          this.dataTable.sort = {
            field: this.dataTable.header[i].name,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    watch: {
      'dataTable.offset': function () {
        this.refreshData()
      },
      'dataTable.paginate': function () {
        this.refreshData()
      },
      'filter.actived': function () {
        this.refreshData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_recipe/List.vue